import '../../../../platform/extensions/common/extensions.js';
const TimelinePaneId = 'timeline';
const TIMELINE_SERVICE_ID = 'timeline';
export { TIMELINE_SERVICE_ID, TimelinePaneId };
